import React, { ReactNode, useEffect, useState } from 'react';
import List, { ListProps } from 'antd/lib/list';
import {
	DragDropContext,
	Draggable,
	Droppable,
	DropResult,
} from 'react-beautiful-dnd';
import styles from './styles'
import './style.css'
import { textStyles } from '../../theme/fonts-ppv';

export interface Item {
	id: number;
	[key: string]: any;
}
interface RBHListProps<T> extends ListProps<T> {
	suffix?: ReactNode;
	dragable?: boolean;
    onSort?: (newItems: T[]) => void;
}
export const RBHList = (props: RBHListProps<Item>) => {
	const [items, setItems] = useState(props.dataSource ?? []);
	const handleDragEnd = (result: DropResult) => {
		if (!result.destination) return;

		const newItems = Array.from(items);
		const [moved] = newItems.splice(result.source.index, 1);
		newItems.splice(result.destination.index, 0, moved);

		setItems(newItems);
        props?.onSort?.(newItems);
	};

	useEffect(() => {setItems(props.dataSource ?? [])}, [props.dataSource])
	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<Droppable droppableId='rbh-list-droppable' direction='vertical'>
				{(provided) => {
					return (
						<div style={styles.dropableContainer} ref={provided.innerRef} {...provided.droppableProps}>
							<List
                                className='rbh-list'
								style={styles.listContainer}
								{...props}
								dataSource={items}
								renderItem={(item, index) => (
									<Draggable
										key={item.id}
										draggableId={String(item.id)}
										index={index}
										isDragDisabled={!props.dragable}
									>
										{(provided) => (
											<div ref={provided.innerRef}>
												<List.Item
													{...provided.dragHandleProps}
													{...provided.draggableProps}
												>
													{props.dragable && (
														<img style={styles.sortImage} src='/RBH.ico/drag-icon.svg' />
													)}
                                                    <div style={{ ...styles.fullWidth, ...textStyles.subtitle2}}>
                                                        {props.renderItem?.(item, index)}
                                                    </div>
												</List.Item>
											</div>
										)}
									</Draggable>
								)}
							/>
							{provided.placeholder}
						</div>
					);
				}}
			</Droppable>
		</DragDropContext>
	);
};
